/**
 * Gemeinsamer Zustand der Intro-Animation.
 * Ersetzt die globalen Variablen window._hasIntroAnimation / window._projectSlider.
 */
let running = false;
let callbacks = [];

export const startIntro = () => {
	running = true;
};

export const isIntroRunning = () => running;

/**
 * Führt cb aus, sobald das Intro den Inhalt freigibt.
 * Läuft kein Intro, wird cb sofort ausgeführt.
 */
export const onIntroReveal = cb => {
	if (running) {
		callbacks.push(cb);
	} else {
		cb();
	}
};

export const revealIntro = () => {
	running = false;
	const queued = callbacks;
	callbacks = [];
	queued.forEach(cb => cb());
};
